import {
    Flex, chakra, Box, Text
} from '@chakra-ui/react';

export const Container = chakra(Flex, {
    baseStyle: {
        flexDirection: 'column',
        w: '560px'
    }
});

export const CloseButtonWrapper = chakra(Box, {
    baseStyle: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        h: '40px',
        right: '-20px',
        top: '-20px'
    }
});

export const CloseButton = chakra(Box, { baseStyle: { cursor: 'pointer' } });

export const MyProfileWrapper = chakra(Flex, {
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        w: '70%',
        flexDirection: 'column',
        ml: '24px',
        color: 'neutral.900',
        fontWeight: 500,
        fontSize: '32px'
    }
});

export const Title = chakra(Text, {
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        color: 'neutral.600',
        fontSize: '16px',
        mb: '8px'
    }
});

export const Description = chakra(Text, {
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        color: 'neutral.900',
        fontWeight: 500,
        fontSize: '20px !important',
        mt: '0 !important',
        letterSpacing: '-0.15px',
        overflow: 'auto'
    }
});

export const Divider = chakra(Box, {
    baseStyle: {
        h: '1px',
        ml: '-20px',
        w: 'calc(100% + 40px)',
        backgroundColor: '#EDF1F4'
    }
});

export const Section = chakra(Flex, {
    baseStyle: {
        m: '12px',
        minHeight: '90px'
    }
});

export const Dash = chakra(Box, {
    baseStyle: {
        w: '30px',
        textAlign: 'center'
    }
});
